module.exports = __webpack_public_path__ + "static/media/SEC_logo.e26497c1.jpg";